import { render, staticRenderFns } from "./RelaiPointCard.vue?vue&type=template&id=a026905a&"
import script from "./RelaiPointCard.vue?vue&type=script&lang=js&"
export * from "./RelaiPointCard.vue?vue&type=script&lang=js&"
import style0 from "./RelaiPointCard.vue?vue&type=style&index=0&id=a026905a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports